import React from 'react';

import { SRLWrapper } from "simple-react-lightbox";
import { all } from '../../assets/images/images';
// Custom components
import AppHeader from '../../components/AppHeader';
// Material components
import { Container, Grid, makeStyles } from '@material-ui/core';
import { fonts } from '../../assets/jss';
const useStyles = makeStyles((theme) => ({
    imageGalleryItem: {
        display: 'flex',
        alignItems: 'center',
        padding: '6px'
    },
    galleryImage: {
        width: '100%'
    }
}));

export default () => {
    const classes = useStyles();
    return (
        <AppHeader>
            <h2 style={fonts.secondary}>Gallery</h2>
            <Container style={{ marginBottom: 50 }}>
                <SRLWrapper>
                    <Grid container>
                        {all.map(image =>
                            <Grid key={image.src} item xs={6} sm={3} className={classes.imageGalleryItem}>
                                <img src={image.src} alt={image.alt} className={classes.galleryImage} />
                            </Grid>
                        )}
                    </Grid>
                </SRLWrapper>
            </Container>
        </AppHeader>
    )
}